import { render, staticRenderFns } from "./UserTitleList.vue?vue&type=template&id=5bb71be2&scoped=true"
import script from "./UserTitleList.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTitleList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserTitleList.vue?vue&type=style&index=0&id=5bb71be2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb71be2",
  null
  
)

export default component.exports